import {Icon} from '@bitstillery/common/components'
import {Amount, SubAmount} from '@bitstillery/common/components'
import {MithrilComponent} from '@bitstillery/mithril'
import {classes} from '@bitstillery/common/lib/utils'
import m from '@bitstillery/mithril'

interface AmountUnitAttrs {
    case_amount_excise?: number | string
    should_include_excise?: boolean

    display_currency?: string | null
    rate?: number | string | null

    case_number_of_bottles?: number | string | null | undefined
    case_amount: number | string | null
    currency: string | null
    excise?: number | string
    origin?:
        | {
              case_amount: number
              currency: string
              case_amount_excise?: number // Only if should_include_excise
          }
        | undefined
    className?: string
}

export class AmountUnit extends MithrilComponent<AmountUnitAttrs> {
    view(vn: m.Vnode<AmountUnitAttrs>) {
        return (
            <div className={classes(vn.attrs.className, 'c-amount-unit')}>
                <div className='amount-bottle'>
                    <Icon name='bottle' size='s' type='unset' />
                    {(() => {
                        if (vn.attrs.currency) {
                            if (vn.attrs.should_include_excise) {
                                return (
                                    <div className='amount-excise'>
                                        <Amount
                                            amount={
                                                Number(vn.attrs.case_amount_excise || 0) / Number(vn.attrs.case_number_of_bottles)
                                            }
                                            currency={vn.attrs.currency}
                                            rate={vn.attrs.rate}
                                        />
                                        <SubAmount
                                            amount={Number(vn.attrs.case_amount) / Number(vn.attrs.case_number_of_bottles)}
                                            currency={vn.attrs.currency}
                                            label='Ex Duty'
                                            rate={vn.attrs.rate}
                                        />
                                    </div>
                                )
                            }
                            return (
                                <Amount
                                    amount={Number(vn.attrs.case_amount) / Number(vn.attrs.case_number_of_bottles)}
                                    currency={vn.attrs.currency}
                                    display_currency={vn.attrs.display_currency}
                                    excise={vn.attrs.excise}
                                    rate={vn.attrs.rate}
                                />
                            )
                        }
                        const bottle_amount = Number(vn.attrs.case_amount) * Number(vn.attrs.case_number_of_bottles)
                        return bottle_amount ? bottle_amount : '-'
                    })()}
                </div>
                {vn.attrs.currency && vn.attrs.origin && vn.attrs.origin.currency !== vn.attrs.currency && (
                    <div className='alt-currency'>
                        <Icon name='money' size='s' />

                        {vn.attrs.should_include_excise ? (
                            <div className='amount-excise'>
                                <Amount
                                    amount={(vn.attrs.origin.case_amount_excise || 0) / Number(vn.attrs.case_number_of_bottles)}
                                    currency={vn.attrs.origin.currency}
                                    excise={vn.attrs.excise}
                                    rate={vn.attrs.rate}
                                />
                                <SubAmount
                                    amount={vn.attrs.origin.case_amount / Number(vn.attrs.case_number_of_bottles)}
                                    currency={vn.attrs.origin.currency}
                                    label='Ex Duty'
                                    rate={vn.attrs.rate}
                                />
                            </div>
                        ) : (
                            <Amount
                                amount={vn.attrs.origin.case_amount / Number(vn.attrs.case_number_of_bottles)}
                                currency={vn.attrs.origin.currency}
                                display_currency={vn.attrs.display_currency}
                                excise={vn.attrs.excise}
                                rate={vn.attrs.rate}
                            />
                        )}
                    </div>
                )}

                <div className='amount-case'>
                    <Icon name='case' size='s' type='unset' />

                    {(() => {
                        if (vn.attrs.currency) {
                            if (vn.attrs.should_include_excise) {
                                return (
                                    <div className='amount-excise'>
                                        <Amount
                                            amount={vn.attrs.case_amount_excise ?? null}
                                            currency={vn.attrs.currency}
                                            rate={vn.attrs.rate}
                                        />
                                        <SubAmount
                                            amount={vn.attrs.case_amount ?? null}
                                            currency={vn.attrs.currency}
                                            label='Ex Duty'
                                            rate={vn.attrs.rate}
                                        />
                                    </div>
                                )
                            }
                            return (
                                <Amount
                                    amount={vn.attrs.case_amount}
                                    currency={vn.attrs.currency}
                                    display_currency={vn.attrs.display_currency}
                                    excise={vn.attrs.excise}
                                    rate={vn.attrs.rate}
                                />
                            )
                        }
                        return vn.attrs.case_amount ? vn.attrs.case_amount : '-'
                    })()}
                </div>

                {vn.attrs.currency && vn.attrs.origin && vn.attrs.origin.currency !== vn.attrs.currency && (
                    <div className='alt-currency'>
                        <Icon name='money' size='s' type='unset' />
                        {vn.attrs.should_include_excise ? (
                            <div className='amount-excise'>
                                <Amount
                                    amount={vn.attrs.origin.case_amount_excise ?? null}
                                    currency={vn.attrs.origin.currency}
                                    rate={vn.attrs.rate}
                                />
                                <SubAmount
                                    amount={vn.attrs.origin.case_amount}
                                    currency={vn.attrs.origin.currency}
                                    label='Ex Duty'
                                    rate={vn.attrs.rate}
                                />
                            </div>
                        ) : (
                            <Amount
                                amount={vn.attrs.origin.case_amount}
                                currency={vn.attrs.origin.currency}
                                display_currency={vn.attrs.display_currency}
                                excise={vn.attrs.excise}
                                rate={vn.attrs.rate ?? 1}
                            />
                        )}
                    </div>
                )}
            </div>
        )
    }
}
